module.exports = __webpack_public_path__ + "static/img/home_showmore_photo6@2x.2ebabd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo6@2x.png
// module id = yRzZ
// module chunks = 0